import React, { Component } from 'react';
import { Stage, Text, TextPath, Layer, Group, Transformer, Rect, Line } from "react-konva";
import { connect } from 'react-redux';
import KeyHandler, { KEYDOWN } from 'react-key-handler';

import CanvasLayer from './CanvasLayer';
import CachedImage from './CachedImage';
import SvgSticker from './SvgSticker';

import { deselectObjects, transformObject, moveObject, deleteObject, updateObjectSizes } from "../actions";

import _forEach from 'lodash/forEach';
import _map from 'lodash/map';
import _filter from 'lodash/filter';
import _uniqBy from 'lodash/uniqBy';
import TemplateCanvasLayer from "./TemplateCanvasLayer";

class CanvasContainer extends Component {

  groupTransformer = null;
  group = null;

  constructor(props) {
    super(props);
    this.handleStageClick = this.handleStageClick.bind(this);
    this.handleTransform = this.handleTransform.bind(this);
    this.handleMultipleTransform = this.handleMultipleTransform.bind(this);
    this.handleMoveHOC = this.handleMoveHOC.bind(this);
    this.handleStickerMoveHOC = this.handleStickerMoveHOC.bind(this);
    this.handleDeleteKeyDown = this.handleDeleteKeyDown.bind(this);
    this.renderText = this.renderText.bind(this);
    this.renderImage = this.renderImage.bind(this);
    this.renderSticker = this.renderSticker.bind(this);
    this.showBoundingBox = this.showBoundingBox.bind(this);
    this.hideBoundingBox = this.hideBoundingBox.bind(this);
    this.updateObjectSizes = this.updateObjectSizes.bind(this);
    this.renderGrids = this.renderGrids.bind(this);
    this.handleCopy = this.handleCopy.bind(this);
    this.renderTransformer = this.renderTransformer.bind(this);
    this.handleKeyMoveHOC = this.handleKeyMoveHOC.bind(this);
  }

  UNSAFE_componentWillReceiveProps(newProps, oldProps) {
    if (newProps.layers.selected.length > 1) {
      this.showBoundingBox(newProps.layers.selected);
    } else {
      this.hideBoundingBox();
    }
  }

  componentDidMount() {
    if (this.props.layers.selected.length > 1) {
      this.showBoundingBox(this.props.layers.selected);
    } else {
      this.hideBoundingBox();
    }

    console.log(this.groupTransformer, this.group);
    this.updateObjectSizes();
  }

  handleStageClick(e) {
    //console.log(e);
    this.props.deselectObjects();
  }

  handleTransform(e) {
    console.log(e);
    this.props.transformObject(e.currentTarget.attrs);
  }

  handleMultipleTransform(e) {
    //console.log(e);

  }

  handleMoveHOC(id) {
    return (e) => {
      console.log(e);
      if (e.target.className === 'Transformer') {
        console.log('This is transformer. Skipped.');
        return;
      }

      this.props.moveObject(id, e.target.attrs.x, e.target.attrs.y);
    };
  }

  handleKeyMoveHOC(payload) {
    return (e) => {
      if (this.props.layers.selected.length !== 1) {
        return;
      }

      const surfaceId = this.props.objects.present.currentSurface.surface.id;
      const object = this.props.objects.present.objects[surfaceId][this.props.layers.selected[0]];

      this.props.moveObject(object.id, object.props.x + payload.x, object.props.y + payload.y);

      //console.log(e);
      if (e.keyCode === 38 || e.keyCode === 40) {
        console.log('UP/DOWN key is ignored');
        e.preventDefault();
      }
    };
  }

  handleStickerMoveHOC(id) {
    return (e) => {
      console.log(e);
      if (e.target.className === 'Transformer') {
        return;
      }

      this.props.moveObject(id, e.target.attrs.x, e.target.attrs.y);
    };
  }

  handleDeleteKeyDown(e) {
    e.preventDefault();
    if (this.props.layers.selected.length > 0) {
      this.props.deleteObject(this.props.layers.selected);
    }
    e.stopPropagation();
  }

  handleCopy(e) {
    console.log(e);
  }

  renderGrids(centerX, centerY, canvas) {
    if (!this.props.canvas.grid) { return null; }

    let grids = [];

    for (let xplus = centerX + 20; xplus < canvas.width; xplus += 20) {
      grids.push(
        <Line x={xplus} y={0} width={1} height={canvas.height} points={[0, 0, 0, canvas.height]} strokeWidth={1} stroke={'#bcbcbc'} />
      )
    }
    for (let xminus = centerX - 20; xminus > 0; xminus -= 20) {
      grids.push(
        <Line x={xminus} y={0} width={1} height={canvas.height} points={[0, 0, 0, canvas.height]} strokeWidth={1} stroke={'#bcbcbc'} />
      )
    }
    for (let yplus = centerY + 20; yplus < canvas.height; yplus += 20) {
      grids.push(
        <Line x={0} y={yplus} width={canvas.width} height={1} points={[0, 0, canvas.width, 0]} strokeWidth={1} stroke={'#bcbcbc'} />
      )
    }
    for (let yminus = centerY - 20; yminus > 0; yminus -= 20) {
      grids.push(
        <Line x={0} y={yminus} width={canvas.width} height={1} points={[0, 0, canvas.width, 0]} strokeWidth={1} stroke={'#bcbcbc'} />
      )
    }

    grids.push(<Line x={centerX} y={0} width={1} height={canvas.height} points={[0, 0, 0, canvas.height]} strokeWidth={1} stroke={'#757575'} />);
    grids.push(<Line x={0} y={centerY} width={canvas.width} height={1} points={[0, 0, canvas.width, 0]} strokeWidth={1} stroke={'#757575'} />);

    return grids;
  }

  renderGuide(canvas, color) {
    if (this.props.canvas.guide) {
      return (
        <Rect {...canvas} stroke={color || '#ff0000'} strokeWidth={0.5}/>
      );
    }
  }

  render() {
    const scale = this.props.canvas.zoom;
    const width = this.props.canvasWidth * scale;
    const height = this.props.canvasHeight * scale;

    const currentSurface = this.props.objects.present.currentSurface;
    const surfaceId = this.props.objects.present.currentSurface.surface.id;
    const objects = this.props.objects.present.objects[surfaceId];
    const index = this.props.objects.present.index[surfaceId];
    const canvas = currentSurface.surface.canvas;

    const className = 't-canvas-container';

    const centerX = (currentSurface.surface.canvas.width / 2);
    const centerY = (currentSurface.surface.canvas.height / 2);

    return (
      <div className={className}>
        {/*<Layers />*/}
        <div className="t-canvas-container-inside" style={{minHeight: height, minWidth: width}}>

          <Stage width={width} height={height} scaleX={this.props.canvas.zoom} scaleY={this.props.canvas.zoom} onClick={this.handleStageClick} style={{backgroundColor: "transparent"}}>
            <Layer listening={false}>
              <CachedImage listening={false} name={'surface'+surfaceId} src={currentSurface.image} {...currentSurface.surface.background} />
              {this.renderGuide(currentSurface.surface.canvas, this.props.products.currentColor.border_color)}
            </Layer>
            <Layer listening={false} x={canvas.x} y={canvas.y}>
              {this.renderGrids(centerX, centerY, currentSurface.surface.canvas)}
            </Layer>
            <Layer x={canvas.x} y={canvas.y} clip={{x: 0, y: 0, width: canvas.width, height: canvas.height}}>
              {this.props.system.isTemplate && this.props.canvas.template.map((template, i) => {
                return this.renderTemplateObject(i, template, canvas);
              })}
              {index.map(id => {
                return this.renderObject(objects[id]);
              })}
              <Group x={0} y={0}>
                <Group x={0} y={0} ref={node => {this.group = node;}} draggable={true} name='temporaryGroup' onTransformEnd={this.handleMultipleTransform}/>
                <Transformer
                  ref={node => {this.groupTransformer = node;}}
                  draggable={true}
                />
              </Group>
            </Layer>
            <Layer>
              {index.map(id => {
                return this.renderTransformer(objects[id]);
              })}
            </Layer>
          </Stage>
          <KeyHandler keyCode={46} onKeyHandle={this.handleDeleteKeyDown} />
          <KeyHandler keyCode={8} onKeyHandle={this.handleDeleteKeyDown} />
          <KeyHandler keyCode={39} onKeyHandle={this.handleKeyMoveHOC({x: 1, y: 0})} />
          <KeyHandler keyCode={37} onKeyHandle={this.handleKeyMoveHOC({x: -1, y: 0})} />
          <KeyHandler keyCode={38} onKeyHandle={this.handleKeyMoveHOC({x: 0, y: -1})} />
          <KeyHandler keyCode={40} onKeyHandle={this.handleKeyMoveHOC({x: 0, y: 1})} />

          <div className="t-canvas-container-font-preview">
            {_map(objects, (object) => {
              if (object.type === 'text') {
                return <span key={"fnt" + object.id} style={{display: 'none', fontFamily: object.props.fontFamily}} id={"font-preview-" + object.id}>{object.props.text}</span>;
              }
            })}
          </div>
        </div>

        {this.renderAlert()}
      </div>
    );
  }

  renderTransformer(object) {
    const anchorConfig = {
      full: ['top-left', 'top-center', 'top-right', 'middle-right', 'middle-left', 'bottom-left', 'bottom-center', 'bottom-right'],
      keepRatio: ['top-left', 'top-right', 'bottom-left', 'bottom-right']
    };

    let rotatable = true;
    if (object && typeof object.rotateEnabled !== 'undefined') {
      rotatable = object.rotateEnabled;
    }

    let resizable = true;
    if (object && typeof object.resizeEnabled !== 'undefined') {
      resizable = object.resizeEnabled;
    }

    let anchors = anchorConfig.full;
    if (object && typeof object.keepRatio !== 'undefined') {
      anchors = anchorConfig[object.keepRatio ? 'keepRatio' : 'full'];
    }

    return (
      <Transformer
        id={"global-transformer-" + object.id}
        key={"global-transformer-" + object.id}
        draggable={true}
        keepRatio={true}
        rotateEnabled={rotatable}
        resizeEnabled={resizable}
        enabledAnchors={anchors}
      />
    );
  }

  /**
   * General object renderer
   * @param object
   */
  renderObject(object) {
    switch (object.type) {
      case 'text':
        if (object.props.data) {
          return this.renderTextPath(object);
        } else {
          return this.renderText(object);
        }
      case 'image':
        return this.renderImage(object);
      case 'sticker':
        return this.renderSticker(object);
      case 'group':
        return this.renderGroup(object);
      default:
        return null;
    }
  }

  renderText(object) {
    return (
      <CanvasLayer key={object.id} id={object.id} type="text" object={object}>
        <Text name={object.id} {...object.props} draggable={true} onTransformEnd={this.handleTransform} onDragEnd={this.handleMoveHOC(object.id)} />
      </CanvasLayer>
    );
  }

  renderTextPath(object) {
    return (
      <CanvasLayer key={object.id} id={object.id} type="text" object={object}>
        <TextPath name={object.id} {...object.props} draggable={true} onTransformEnd={this.handleTransform} onDragEnd={this.handleMoveHOC(object.id)}  />
      </CanvasLayer>
    );
  }

  renderImage(object) {
    return (
      <CanvasLayer key={object.id} id={object.id} type="image" object={object}>
        <CachedImage name={object.id} src={object.src} props={object.props} draggable={true} onTransformEnd={this.handleTransform} onDragEnd={this.handleMoveHOC(object.id)} />
      </CanvasLayer>
    );
  }

  renderSticker(object) {
    if (object.src.match(/.svg$/)) {
      return (
        <CanvasLayer key={object.id} id={object.id} type="sticker" object={object}>
          {/*<Path name={object.id} data="m456 303.789062h-24v-104c0-13.257812-10.746094-24-24-24h-56v-72c0-4.417968-3.582031-8-8-8h-32c-4.417969 0-8 3.582032-8 8v72h-40v-72c0-4.417968-3.582031-8-8-8h-32c-4.417969 0-8 3.582032-8 8v72h-40v-72c0-4.417968-3.582031-8-8-8h-32c-4.417969 0-8 3.582032-8 8v72h-56c-13.253906 0-24 10.742188-24 24v104h-24c-13.253906 0-24 10.742188-24 24v128c0 13.253907 10.746094 24 24 24h432c13.253906 0 24-10.746093 24-24v-128c0-13.257812-10.746094-24-24-24zm8 24v5.160157c-7.832031 8.886719-19.933594 12.71875-31.453125 9.960937-11.523437-2.753906-20.578125-11.652344-23.539063-23.121094h46.992188c4.417969 0 8 3.582032 8 8zm-56-136c4.417969 0 8 3.582032 8 8v11.742188c-4.859375 2.8125-10.382812 4.28125-16 4.257812-14.585938-.019531-27.324219-9.882812-30.992188-24zm-88-80h16v64h-16zm30.992188 80c-3.636719 14.144532-16.386719 24.03125-30.992188 24.03125s-27.355469-9.886718-30.992188-24.03125zm-118.992188-80h16v64h-16zm38.992188 80c-3.636719 14.144532-16.386719 24.03125-30.992188 24.03125s-27.355469-9.886718-30.992188-24.03125zm-80 0c-3.636719 14.144532-16.386719 24.03125-30.992188 24.03125s-27.355469-9.886718-30.992188-24.03125zm-46.992188-80h16v64h-16zm-80 88c0-4.417968 3.582031-8 8-8h38.992188c-3.667969 14.117188-16.40625 23.980469-30.992188 24-5.617188.023438-11.140625-1.445312-16-4.257812zm0 29.230469c20.757812 7.386719 43.875-.355469 56-18.75 8.875 13.433594 23.898438 21.515625 40 21.515625s31.125-8.082031 40-21.515625c8.875 13.433594 23.898438 21.515625 40 21.515625s31.125-8.082031 40-21.515625c8.875 13.433594 23.898438 21.515625 40 21.515625s31.125-8.082031 40-21.515625c12.125 18.394531 35.242188 26.136719 56 18.75v74.769531h-352zm326.992188 90.769531c-3.636719 14.144532-16.386719 24.03125-30.992188 24.03125s-27.355469-9.886718-30.992188-24.03125zm-80 0c-3.636719 14.144532-16.386719 24.03125-30.992188 24.03125s-27.355469-9.886718-30.992188-24.03125zm-80 0c-3.636719 14.144532-16.386719 24.03125-30.992188 24.03125s-27.355469-9.886718-30.992188-24.03125zm-80 0c-3.636719 14.144532-16.386719 24.03125-30.992188 24.03125s-27.355469-9.886718-30.992188-24.03125zm-134.992188 8c0-4.417968 3.582031-8 8-8h46.992188c-2.960938 11.46875-12.015626 20.367188-23.539063 23.121094-11.519531 2.757813-23.621094-1.074218-31.453125-9.960937zm440 136h-432c-4.417969 0-8-3.582031-8-8v-102.5625c21.910156 12.863282 50.058594 6.285157 64-14.957031 8.875 13.433594 23.898438 21.515625 40 21.515625s31.125-8.082031 40-21.515625c8.875 13.433594 23.898438 21.515625 40 21.515625s31.125-8.082031 40-21.515625c8.875 13.433594 23.898438 21.515625 40 21.515625s31.125-8.082031 40-21.515625c8.875 13.433594 23.898438 21.515625 40 21.515625s31.125-8.082031 40-21.515625c13.941406 21.242188 42.089844 27.820313 64 14.957031v102.5625c0 4.417969-3.582031 8-8 8zm0 0,m240 87.789062c17.671875 0 32-14.328124 32-32 0-14.992187-21.167969-46.402343-25.414062-52.546874-1.574219-2.042969-4.007813-3.242188-6.585938-3.242188s-5.011719 1.199219-6.585938 3.242188c-4.246093 6.144531-25.414062 37.554687-25.414062 52.546874 0 17.671876 14.328125 32 32 32zm0-65.433593c8.535156 13.601562 16 28.128906 16 33.433593 0 8.835938-7.164062 16-16 16s-16-7.164062-16-16c0-5.296874 7.464844-19.800781 16-33.433593zm0 0,m328 87.789062c17.671875 0 32-14.328124 32-32 0-14.992187-21.167969-46.402343-25.414062-52.546874-1.574219-2.042969-4.007813-3.242188-6.585938-3.242188s-5.011719 1.199219-6.585938 3.242188c-4.246093 6.144531-25.414062 37.554687-25.414062 52.546874 0 17.671876 14.328125 32 32 32zm0-65.433593c8.535156 13.601562 16 28.128906 16 33.433593 0 8.835938-7.164062 16-16 16s-16-7.164062-16-16c0-5.296874 7.464844-19.800781 16-33.433593zm0 0,m152 87.789062c17.671875 0 32-14.328124 32-32 0-14.992187-21.167969-46.402343-25.414062-52.546874-1.574219-2.042969-4.007813-3.242188-6.585938-3.242188s-5.011719 1.199219-6.585938 3.242188c-4.246093 6.144531-25.414062 37.554687-25.414062 52.546874 0 17.671876 14.328125 32 32 32zm0-65.433593c8.535156 13.601562 16 28.128906 16 33.433593 0 8.835938-7.164062 16-16 16s-16-7.164062-16-16c0-5.296874 7.464844-19.800781 16-33.433593zm0 0" {...object.props} onTransformEnd={this.handleTransform} />*/}
          <SvgSticker name={object.id} props={object.props} draggable={true} onTransformEnd={this.handleTransform} object={object} onDragEnd={this.handleStickerMoveHOC(object.id)} />
        </CanvasLayer>
      );
    }

    return (
      <CanvasLayer key={object.id} id={object.id} type="sticker" object={object}>
        <CachedImage name={object.id} src={object.src} props={object.props} draggable={true} onTransformEnd={this.handleTransform} onDragEnd={this.handleMoveHOC(object.id)} />
      </CanvasLayer>
    );
  }

  renderGroup(object) {
    return (
      <CanvasLayer key={object.id} id={object.id} type="group" onDragEnd={this.handleMoveHOC(object.id)} object={object}>
        {object.index.map(id => {
          const child = object.objects[id];
          switch (child.type) {
            case 'text':
              if (child.props.data) {
                return (<TextPath name={child.id} {...child.props} onTransformEnd={this.handleTransform} />);
              } else {
                return (<Text name={child.id} {...child.props} onTransformEnd={this.handleTransform} />);
              }
            case 'image':
              return (<CachedImage name={object.id} src={object.src} props={object.props} onTransformEnd={this.handleTransform} />);
            default:
              return null;
          }
        })}
      </CanvasLayer>
    );
  }

  renderAlert() {
    if ((this.props.objects.present.collision || []).length > 0) {
      const filtered = _filter(this.props.objects.present.collision, (o) => o.intersectionAvailable === false);
      const unique = _uniqBy(filtered, (o) => o.src);
      return (
        <div className="t-canvas-alert">
          {unique.map((obj) => {
            return (
              <span className="t-canvas-alert-preview" style={{backgroundImage: `url(${obj.src})`}} />
            );
          })}
          このスタンプは他のスタンプと重ねることができません。
        </div>
      );
    }
  }

  renderTemplateObject(index, template, canvas) {
    switch (template.type) {
      case 'text':
        if (this.props.canvas.templateObjects[template.id]) {
          return null;
        }
        return (
          <Group key={"tpk" + index} x={template.x * canvas.width} y={template.y * canvas.height}>
            {this.props.canvas.guide && (<Rect x={0} y={0} width={canvas.width * template.width} height={canvas.height * template.height} stroke={template.color || '#ff0000'} strokeWidth={0.5} />) }
            <Text x={0} y={0} width={canvas.width * template.width} height={canvas.height * template.height} {...template.props} text={template.name} opacity={0.2} />
            <Rect fill={template.color} x={canvas.width * template.width - 20} y={0} width={20} height={20} />
            <Text fill={'#ffffff'} x={canvas.width * template.width - 20} y={0}  width={20} height={20} align='center' verticalAlign='middle' text={index + 1} />
          </Group>
        );
      case 'image':
        if (this.props.canvas.templateObjects[template.id]) {
          return null;
        }
        return (
          <Group key={"tpk" + index} x={template.x * canvas.width} y={template.y * canvas.height} clip={{x: 0, y: 0, width: canvas.width * template.width, height: canvas.height * template.height}}>
            {/*<TemplateCanvasLayer templateIndex={index} key={'template'  + index} id={'template'  + index} type="image" object={template} onDragEnd={(e) => {console.info(e);}}>*/}
            {/*  <CachedImage name={'template'  + index} src={template.props.src} props={template.props} draggable={true} onDragEnd={(e) => {console.info(e);}} />*/}
            {/*</TemplateCanvasLayer>*/}
            {this.props.canvas.guide && (<Rect x={0} y={0} width={canvas.width * template.width} height={canvas.height * template.height} stroke={template.color || '#ff0000'} strokeWidth={0.5} />) }
            <Text x={0} y={0} width={canvas.width * template.width} height={canvas.height * template.height} verticalAlign="middle" text={template.name} opacity={0.2} />
            <Rect fill={template.color} x={canvas.width * template.width - 20} y={0} width={20} height={20} />
            <Text fill={'#ffffff'} x={canvas.width * template.width - 20} y={0}  width={20} height={20} align='center' verticalAlign='middle' text={index + 1} />
          </Group>
        );
    }
  }

  showBoundingBox(ids) {
    const stage = this.groupTransformer.getStage();

    this.groupTransformer.attachTo(this.group);

    _forEach(ids, v => {
      const target = stage.findOne(node => {
        return node.name() === (v);
      });

      this.group.add(target);
    });

    this.groupTransformer.forceUpdate();
    this.groupTransformer.getLayer().batchDraw();
  }

  hideBoundingBox() {
    if (!this.groupTransformer) {
      return;
    }

    const stage = this.groupTransformer.getStage();

    const children = this.group.getChildren();

    _forEach(children, child => {
      if (child) {
        const group = stage.findOne(node => {
          return node.name() === (child.name() + '-group');
        });

        group.add(child);
      }
    });

    this.groupTransformer.detach(this.group);
    this.groupTransformer.getLayer().batchDraw();
  }

  updateObjectSizes() {
    const stage = this.groupTransformer.getStage();
    const surfaceId = this.props.objects.present.currentSurface.surface.id;
    const index = this.props.objects.present.index[surfaceId];
    const sizes = {};
    _forEach(index, id => {
      const target = stage.findOne(node => {
        return node.name() === id;
      });

      const scale = target.scale();

      sizes[id] = {
        width: target.getWidth() * scale.x,
        height: target.getHeight() * scale.y
      };
    });

    this.props.updateObjectSizes(sizes);
  }
}

export default connect(f => f, {deselectObjects, transformObject, moveObject, deleteObject, updateObjectSizes})(CanvasContainer);



// WEBPACK FOOTER //
// ./src/components/CanvasContainer.js